import { mq, COLOR, Input as _Input, FONT_SIZE } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { AnimationContainer } from "~/components/blocks/layout/global-navi/mobile/right/search-form/style";
import { GLOBAL_NAVI_HEIGHT } from "~/styles/layout";

const GLOBAL_NAVI_BORDER_WIDTH = 1;

export const DivAnimationContainer = styled(AnimationContainer)`
  position: absolute;
  padding: 8px 16px;
  top: 0;
  width: 100%;
  height: ${GLOBAL_NAVI_HEIGHT.PC}px;
  display: flex;
  align-items: center;
  background-color: ${COLOR.GRAY100.code};
  ${mq.sp} {
    height: ${GLOBAL_NAVI_HEIGHT.SP - GLOBAL_NAVI_BORDER_WIDTH * 2}px;
    padding: 6px 8px;
  }

  /*
   FIXME(uchida):
   InputSearchFormのルートのdivを指定
   InputSearchFormに直接指定するとlabelへ反映されてしまうため
   */
  > div[role="group"] {
    width: 100%;
    height: 100%;
  }
`;

export const InputSearchForm = styled(_Input)`
  height: 100%;

  span {
    padding-left: 16px;
  }
  input {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 8px;
    color: ${COLOR.GRAY900.code};
    ::placeholder {
      font-size: ${FONT_SIZE.S}px;
      color: ${COLOR.GRAY500.code};
    }
    :focus {
      outline: none;
    }
  }

  ${mq.sp} {
    input {
      ::placeholder {
        font-size: ${FONT_SIZE.S}px;
      }
    }
  }
`;

export const Button = styled.button`
  font-size: 12px;
  white-space: nowrap;
  padding-left: 8px;
`;
